import CoreLayout from './component'

export default CoreLayout
